import { useQuery } from '@tanstack/react-query';
import { BannersQueryModel, CustomMoviesQueryModel } from '../types';
import { getHomePageCustomRows } from '@http/endpoints/home';

type useHomePageCustomRowsQueryModel = {
  movies: CustomMoviesQueryModel;
  status: string;
  message: string | null;
  banners: BannersQueryModel;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
};

const useHomePageCustomRowsQuery = (homePageStatus: boolean): useHomePageCustomRowsQueryModel => {
  const { data, isLoading, isError, isSuccess } = useQuery(['homepagecustom'], getHomePageCustomRows, {
    enabled: homePageStatus,
  });
  const banners = data?.data?.banners;
  const movies = data?.data?.movies;
  const status = data?.status;
  const message = data?.message;

  return { movies, status, message, banners, isLoading, isError, isSuccess };
};

export default useHomePageCustomRowsQuery;
